import ReactSelect from 'react-select';
import { FormErrorMessage, FormControl } from '@chakra-ui/react';
import { Field, ErrorMessage } from 'formik';
import { KSelectStylesConfig } from '@/ui-library/design-system/constants/KSelect.styles';
import { NoOptionsMessage } from '@/components/select';
import { customFilterStyles } from '@/design-system/select/customFilterStyles';

export const Select = ({ components = {}, ...props }) => {
  const defaultComponents = {
    IndicatorSeparator: null,
    NoOptionsMessage,
  };

  return (
    <ReactSelect
      styles={KSelectStylesConfig({})}
      components={{ ...defaultComponents, ...components }}
      getOptionLabel={(option) => option.label}
      getOptionValue={(option) => option.value}
      {...props}
    />
  );
};

export const FormSelect = ({
  id,
  onChange = () => {},
  onOpen = () => {},
  ...selectProps
}) => {
  if (!id) {
    console.error('id is required for form field');
    return;
  }

  return (
    <Field name={id} id={id}>
      {({ field: { value }, form }) => (
        <FormControl
          isRequired
          isInvalid={form.errors?.[id] && form.touched?.[id]}
        >
          <Select
            {...selectProps}
            className={`kula_custom_select__container`}
            classNamePrefix="kula_custom_select"
            value={value}
            hasError={form.errors?.[id] && form.touched?.[id]}
            onMenuOpen={onOpen}
            onChange={(selected) => {
              form?.setFieldValue(id, selected);
              onChange(selected);
            }}
            styles={customFilterStyles(selectProps?.newStyles || [])}
          />
          <FormErrorMessage>
            <ErrorMessage name={id} />
          </FormErrorMessage>
        </FormControl>
      )}
    </Field>
  );
};
